module.exports = __webpack_public_path__ + "static/34e0e4c0-c294-49bb-9a8e-1b2cafd54e32-cca18f477933b2d414ac116c7847be31.woff";